/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class GcpMachineTypesResponse {
  /**
  * The machine types list
  */
  'machineTypes'?: Array<string>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "machineTypes",
      "baseName": "machineTypes",
      "type": "Array<string>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return GcpMachineTypesResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

